/**
 * Header Layout
 *
 * @file header.js
 */

import $ from 'jquery';


const header = (() => {

  const HeaderMenu = () => {
    if(window.innerWidth >= 1024){
      $(".header-menu ul li").hover(function(){
        if($(this).find("svg").length > 0){
          $(".header-menu-shadow").removeClass("hidden");
        }
        $(this).children("a").addClass("fade-in-after");
      },function(){
        if($(this).find("svg").length > 0){
          $(".header-menu-shadow").addClass("hidden");
        }
        setTimeout(() => {
          $(this).children("a").removeClass("fade-in-after");
        }, 500);
      });
    } else{
      $(".mobile-menu-toggle").on("click", function(){
        $(this).toggleClass("active");
        $(".login-register-profile").toggleClass("mb-active");
        $(".header-menu").toggleClass("mb-active");
      });
      $(".header-menu ul li>a").on("click", function(){
        $(this).next(".mega-menu").toggle();
      });
      $(".mobile-profile-mn").on("click", function(){
        $(".user-profile-open-menu").toggleClass("hidden");
      });
    }
  };

  const userProfileMenu = () => {
    $(".user-profile-dropdown").on("click", function(){
      $(".user-profile-open-menu").toggleClass("hidden");
    });
  };

  const userLeftProfileMenu = () => {
    console.log();
    function scrollWindowMenu(){
      if($(window).scrollTop() > 115){
        $(".header-right-menu-toggle").addClass("fix-to-bottom");
      } else{
        $(".header-right-menu-toggle").removeClass("fix-to-bottom");
      }
    }
    
    scrollWindowMenu();
    $(window).scroll(function(){
      scrollWindowMenu();
    });

    function isLargeScreen() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    $(".header-right-menu-toggle").hover(
        function () {
            if (isLargeScreen()) {
                $("body").addClass("overflow-hidden");
                $(".header-right-menu-backdrop").addClass("show-background");
            }
        },
        function () {
            if (isLargeScreen()) {
                $("body").removeClass("overflow-hidden");
                $(".header-right-menu-backdrop").removeClass("show-background");
            }
        }
    );

    $(window).resize(function () {
        if (isLargeScreen()) {
            $("body").removeClass("overflow-hidden");
            $(".header-right-menu-backdrop").removeClass("show-background");
        }
    });

    $(".header-right-menu-container").on("mouseleave", function(){
      $(this).find("div").removeClass("js-active");
    });
    
    document.addEventListener('DOMContentLoaded', function () {
      const selectedMenu = document.querySelector('.selected-menu');
      const headerRightMenu = document.querySelector('.header-right-menu');
      const headerRightMenuToggle = document.querySelector('.header-right-menu-toggle'); // Parent div
  
      if (selectedMenu && headerRightMenu && headerRightMenuToggle) {
          function toggleHeaderMenu() {
              const isActive = selectedMenu.classList.contains('active');
              const isSmallScreen = window.matchMedia('(max-width: 1024px)').matches;
  
              if (isActive && isSmallScreen) {
                  // headerRightMenu.style.display = 'block';
                  $("body").addClass("overflow-hidden");
                  headerRightMenuToggle.classList.add('menu-visible'); // Yeni sınıf ekle
              } else {
                  // headerRightMenu.style.display = 'none';
                  $("body").removeClass("overflow-hidden");
                  headerRightMenuToggle.classList.remove('menu-visible'); // Sınıfı kaldır
              }
          }
  
          // Başlangıç durumunu kontrol et
          toggleHeaderMenu();
  
          // Class değişimlerini ve ekran boyutunu dinle
          selectedMenu.addEventListener('click', function () {
              selectedMenu.classList.toggle('active');
              toggleHeaderMenu();
          });
  
          window.addEventListener('resize', toggleHeaderMenu);
      }
    });  
  };

  const stickyHeader = () => {
    const header = document.querySelector('header');
    if (!header) return;

    const headerHeight = header.offsetHeight;

    function handleScroll() {
      if (window.scrollY > headerHeight) {
        header.classList.add('sticky-header');
      } else {
        header.classList.remove('sticky-header');
      }
    }

    // Sayfa yüklendiğinde kontrol et
    handleScroll();

    // Scroll event'ini dinle
    window.addEventListener('scroll', handleScroll);
  };

  const footerMenu = () => {
    document.addEventListener("DOMContentLoaded", () => {
      const isSmallViewport = () => window.innerWidth < 680;
    
      const menuTitles = document.querySelectorAll(".footer-menu-title");
    
      menuTitles.forEach((title) => {
        title.addEventListener("click", () => {
          if (isSmallViewport()) {
            const navParent = title.closest("nav");
            if (navParent) {
              navParent.classList.toggle("active");
            }
          }
        });
      });
    
      window.addEventListener("resize", () => {
        if (!isSmallViewport()) {
          document.querySelectorAll("nav.active").forEach((nav) => {
            nav.classList.remove("active");
          });
        }
      });
    });
  };

  const init = () => {
    stickyHeader();
    HeaderMenu();
    userProfileMenu();
    userLeftProfileMenu();
    footerMenu();
  };

  return {
    init,
  };
})();

export default header;
